var map = {
	"./american-express.png": "f0dc",
	"./credit-card.png": "2bec",
	"./diners-club.png": "78bf",
	"./discover.png": "5854",
	"./elo.png": "4549",
	"./hiper.png": "39ee",
	"./hipercard.png": "762f",
	"./jcb.png": "78f0",
	"./maestro.png": "5c66",
	"./mastercard.png": "72f3",
	"./mir.png": "b676",
	"./unionpay.png": "bd35",
	"./visa.png": "b8e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b656";